import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Icon, Link } from 'atoms';
import { useDispatch, useSelector } from 'react-redux';
import { setFullscreen } from 'app/shared/store/slices/gameLauncherSlice';
import { recursiveUrlDecode } from 'foundation/Helpers/utils';
import { getParam } from 'foundation/url';

const GameLauncherLink = props => {
  const dispatch = useDispatch();
  const gameLauncher = useSelector(state => state.gameLauncher);

  useEffect(() => {
    dispatch(setFullscreen({ fullscreen: false }));
  }, []);

  const toggleFullscreen = (e) => {
    let element = document.getElementById('GamePage');
    if(gameLauncher.fullscreen) {
      dispatch(setFullscreen({ fullscreen: false }));
      element.classList.remove('fullscreen');
      element = document.getElementById('o-game');
      element.classList.remove('o-game--full-screen');
    } else {
      dispatch(setFullscreen({ fullscreen: true }));
      element.classList.add('fullscreen');
      element = document.getElementById('o-game');
      element.classList.add('o-game--full-screen');
    }
  };

  const HeaderLink = (link) => {

    if(link.Icon === 'icon-full-screen') {
      link.Link.onClick = toggleFullscreen;
      link.Link.CssClass = 'o-game-header__link--full-screen';
    } else if(link.Icon === 'icon-exit-full-screen') {
      link.Link.onClick = toggleFullscreen;
      link.Link.CssClass = 'o-game-header__link--minimize';
    } else if(link.Icon === 'icon-close') {
      const returnUrl = getParam("returnUrl");
      if (returnUrl) {
        link.Link.Url = recursiveUrlDecode(returnUrl);
      } else {
        link.Link.Url = props.lobbyUrl;
      }
    }

    if(!link.ShowTextFieldFirst) {
      link.Link.CssClass += ' o-game-header__link--reverted';
    }

    return <Link onClick={link.Link.onClick} target={link.Link.Target} href={link.Link.Url} className={`a-link--icon a-link--icon-before o-game-header__link ${link.Link.CssClass}`}>
      {link.ShowTextFieldFirst && link.Link.Title}
      <Icon iconId={`#${link.Icon}`} className={'a-icon--link'}/>
      {!link.ShowTextFieldFirst && link.Link.Title}
    </Link>;
  };

  return (
    <>
      {Object.keys(props.links).map((linkObject, i) => {
        return <HeaderLink key={i} {...props.links[linkObject]} />;
      })}
    </>
  );
};

GameLauncherLink.propTypes = {
  lobbyUrl: PropTypes.string,
  links: PropTypes.array
};

GameLauncherLink.defaultProps = {
  lobbyUrl: null,
  links: []
};

export default GameLauncherLink;